// extracted by mini-css-extract-plugin
export default {"dropdownWrapper":"T__22MEB9iff1_WlKHQm","droplink":"xNQtiByBjSRPMvY2oc0X","submenu":"DcMljjqSnQT_VoIb8BYk"};